export class NL_ProgramAyarlari {
    ID: number;
    YaziciAdi: string;
    BarkodYaziciAdi:string;
    FisYaziciAdi:string;
}


// WEBPACK FOOTER //
// ./src/models/NL_ProgramAyarlari.ts